import { HTMLProps } from "react";
import { default as ReactMarkdown } from "react-markdown";
import rehypeRaw from "rehype-raw";
import { cn, isExternalUrl } from "@/utils/helpers";
import styles from "./Markdown.module.css";

interface MarkdownProps extends HTMLProps<HTMLElement> {
	// children?: string;
	// className?: string;
}

export default function Markdown({
	children,
	className
} : MarkdownProps) {
	
	function LinkRenderer({
		href,
		children,
		...props
	} : HTMLProps<HTMLAnchorElement>) {
		return (
			<a
				href={href}
				target={href && isExternalUrl(href) ? "_blank" : undefined}
				{...props}
			>
				{children}
			</a>
		);
	};
	
	return (
		<div
			className={cn(
				styles.Markdown,
				className
			)}
		>
			{typeof children === "string" ?
				<ReactMarkdown
					rehypePlugins={[
						rehypeRaw
					]}
					components={{
						a: LinkRenderer
					}}
				>
					{children}
				</ReactMarkdown>
			: children}
		</div>
	);
}
